import React from 'react';
import './LearnerProfilesSection.css';
import Certificate1 from '../assets/images/learningcontent/learner-profiles-image-01.jpeg';
import Certificate2 from '../assets/images/learningcontent/learner-profiles-image-02.jpeg';
import Certificate3 from '../assets/images/learningcontent/learner-profiles-image-03.jpeg';
import Certificate4 from '../assets/images/learningcontent/learner-profiles-image-04.jpeg';
import Certificate5 from '../assets/images/learningcontent/learner-profiles-image-05.jpeg';
import Certificate6 from '../assets/images/learningcontent/learner-profiles-image-06.jpeg';


const LearnerProfilesSection = () => {
  return (
	<div className="learner-profiles-section">
	  <h2 className="learner-profiles-title">Learning Profiles</h2>
	  <p className="learner-profiles-description">受講対象&ライフステージ</p>
	  <div className="learner-profiles-cards">
		<div className="learner-profiles-card">
		  <img src={Certificate1} alt="Company 1" />
		  <h3>高校生・大学生相当</h3>
		  <p>地方在住で高校や大学の無い地域に住んでいる方、不登校で将来に不安を抱えている方、将来のスキルをしっかり身につけられる学校を探している方、未来の選択肢が広がります。</p>
		</div>
		<div className="learner-profiles-card">
		  <img src={Certificate2} alt="Company 2" />
		  <h3>子育て世代</h3>
		  <p>育児と仕事を両立しながらスキルアップしたいあなたへ。在宅で受講可能なオンライン授業と実践演習で、複業・フリーランスに必要なノウハウを身につけます。</p>
		</div>
		<div className="learner-profiles-card">
		  <img src={Certificate3} alt="Company 3" />
		  <h3>インクルーシブ・ラーナー</h3>
		  <p>聴覚に障害がある方、身体に障害がある方、就労継続支援A型施設に通っている方に対し、字幕対応、メタバースでの学習と仕事、就職ではない新しい働き方の形など、解決策を多数ご用意しております。</p>
		</div>
		<div className="learner-profiles-card">
		  <img src={Certificate4} alt="Company 1" />
		  <h3>地方や海外在住の方</h3>
		  <p>都市部に行かないとチャンスがないと思っていませんか？地方からでも受講できるメタバース学習と企業連携で、リモート転職・半農半ＩＴ・起業など多様な働き方をサポートします。字幕対応やリアルタイム翻訳、現地講師の対応で、どこからでも受講できます。</p>
		</div>
		<div className="learner-profiles-card">
		  <img src={Certificate5} alt="Company 2" />
		  <h3>30代から60代までの再挑戦</h3>
		  <p>今の仕事は自由が効かない、もう少し稼ぎたい、今からでも新たな挑戦をしたい。そんな方が自分の働き方を手に入れることができます。いつからでもスタートができます。全力でサポートします。</p>
		</div>
		<div className="learner-profiles-card">
		  <img src={Certificate6} alt="Company 3" />
		  <h3>高収入を目指す20代</h3>
		  <p>未経験からエンジニアを目指して、高収入を獲得したい方。業界に入るための、最初の実務経験を積むことができ、さらに未経験採用の企業との連携があります。就職だけでなく、起業やフリーランスも目指せます。</p>
		</div>
	  </div>
	</div>
  );
};

export default LearnerProfilesSection;